//GENERAL REQUEST
export const PRODUCT_REQUEST_PENDING = "PRODUCT_REQUEST_PENDING";
export const PRODUCT_REQUEST_FAILURE = "PRODUCT_REQUEST_FAILURE";

//GET PRODUCT
export const GET_PRODUCT_REQUEST_SUCCESS = "GET_PRODUCT_REQUEST_SUCCESS";

//POST PRODUCT
export const POST_PRODUCT_REQUEST_SUCCESS = "POST_PRODUCT_REQUEST_SUCCESS";

//PATCH PRODUCT
export const PATCH_PRODUCT_REQUEST_SUCCESS = "PATCH_PRODUCT_REQUEST_SUCCESS";

//DELETE PRODUCT
export const DELETE_PRODUCT_REQUEST_SUCCESS = "DELETE_PRODUCT_REQUEST_SUCCESS";
